export default {
    setActiveDropdown({ commit }, id) {
        commit('setActiveDropdown', id);
    },
    closeAllDropdowns({ commit }) {
        commit('closeAllDropdowns');
    }
} 